import React, { createContext, useState, useEffect } from 'react';

export const authContext = createContext();

const AuthtenticationContext = ({ children }) => {
    const authStatus = localStorage.getItem('authentication');

    const[isAuthenticated, setIsAuthenticated] = useState(authStatus ? JSON.parse(authStatus) : false);
    const setAuthenticationStatus = (status) =>{
        setIsAuthenticated(status)
    }

    useEffect(() => {
       sessionStorage.setItem("authentication", JSON.stringify(isAuthenticated))
       // store alternative details in local storage
       localStorage.setItem("authentication", JSON.stringify(isAuthenticated))
    })

    return (
        <authContext.Provider value={{
            isAuthenticated,
            setAuthenticationStatus
        }}>
            { children }
        </authContext.Provider>
    )
}

export default AuthtenticationContext;
